import { User } from "@auth0/auth0-react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../models/interfaces";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    auth0User: undefined as User | undefined,
    korraUser: null as IUser | null,
    // Token carried by a preview link (sasTokenPreview). Minted tokens live in
    // React Query, see hooks/useSasToken.
    previewSasToken: "",
    haveSSO: undefined as boolean | undefined,
  },
  reducers: {
    setAuth0User: (state, action: PayloadAction<User>) => {
      state.auth0User = action.payload;
    },
    setAuth0SSO: (state, action: PayloadAction<boolean>) => {
      state.haveSSO = action.payload;
    },
    setKorraUser: (state, action: PayloadAction<IUser>) => {
      state.korraUser = action.payload;
    },
    setPreviewSasToken: (state, action: PayloadAction<string>) => {
      state.previewSasToken = action.payload;
    },
  },
});

export const { setAuth0User, setKorraUser, setPreviewSasToken, setAuth0SSO } =
  authSlice.actions;
export default authSlice.reducer;
